import * as mobx from 'mobx';
import { observable, action, useStrict, computed, asMap } from 'mobx';
import BaseStore from './base';
import * as API_REQ from '../apis/req';
import base from '../util/base';
import * as Util from '../util/formUtil';
import * as continuationProcessUtil from '../util/continuationProcessUtil';
import * as _ from '../util/public/common';
import * as GlobalUtil from '../util/public/globalUtil';
import { getInvoiceCloudToken } from './../util/public/invoiceUtil';
import * as EncryptUtil from '../util/public/encryptUtil';
import loadjs from 'loadjs';
import objectAssign from 'object-assign';
import { getAntd, getEcCom, getComsMobx } from '../util/convert';
import * as authTypes from "../constants/secondAuthType";
import { doFileUpload } from "../util/submit";
import { doFreeWorkflow } from "../util/rightBtn";
import { setDocParam } from "../util/public/odocUtil";
import { cloneDeep } from 'lodash';
import * as type from '../constants/type';
import { conformRule } from '../util/conformRuleUtil';
const { WeaTools, WeaLocaleProvider } = getEcCom();
const { ls } = WeaTools;

//useStrict(true);
export class GlobalStore extends BaseStore {
  @observable JSComplete = false;     //标识完整组件库资源是否加载完成
  JSCompleteEvent = [];
  browserVersion = "";
  urlParams = {};

  @observable loading = false;
  @observable tabKey = "form";
  @observable btnDisabled = true;
  @observable apiBtnDisabled = false;
  @computed get baseParam() {  //基础参数
    let baseParam = {}
    GlobalUtil.baseParamRange.map(k => {
      baseParam[k] = this.commonParam[k];
    });
    return baseParam;
  }
  @computed get commonApiParam() {     //常用参数，供后端API接口调用
    let apiParam = {}
    GlobalUtil.commonApiParamRange.map(k => {
      apiParam[k] = this.commonParam[k];
    });
    return apiParam;
  }
  @computed get belongUserStr() {
    const { f_weaver_belongto_userid, f_weaver_belongto_usertype } = this.commonParam;
    return `&f_weaver_belongto_userid=${f_weaver_belongto_userid}&f_weaver_belongto_usertype=${f_weaver_belongto_usertype}`;
  }
  @computed get isSourceLayout() {
    const { layoutversion } = this.commonParam;
    return layoutversion === 0 || layoutversion === 1;
  }
  commonParam = {};       //常用有效参数
  invalidParam = {};      //剩余无效参数,后期去掉
  @observable submitParam = {};

  @observable markInfo = {};  //签字意见输入框相关信息
  closeNeedPrompt = true;     //离开表单是否提示
  @observable rightMenu = {};     //右键菜单
  @observable dialogVisible = observable.map ? observable.map({}) : asMap({});    //弹窗显示属性
  @observable invertionInfo = {}; //流程干预
  @observable promptInfo = {};    //顶部提示信息
  @observable remindInfo = {};    //提醒信息
  @observable secondAuthInfo = {};    //数据保护验证的信息
  @observable secLevelInfo = {};//密级信息
  @observable continuationProcessInfo = {};//流程连续处理信息
  @observable conflictFieldMap = observable.map ? observable.map({}) : asMap({}); //表单冲突字段
  @observable odocIframeUrl = ''
  @observable btnLabelName = {}; //签字意见框按钮显示名称

  constructor() {
    super();
    this.browserVersion = Util.getBrowserVersion();
  }


  @action('控制JS是否异步加载完成')
  markJSComplete = () => {
    this.JSComplete = true;
  }

  @action('添加全量组件库加载完后才能执行的事件')
  pushJSCompleteEvent = (fn) => {
    if (typeof fn === "function") {
      if (this.JSCompleteEvent instanceof Array)
        this.JSCompleteEvent.push(fn);
      else    //已经执行过一次的情况，直接触发
        fn();
    }
  }

  @action('执行加载完事件，仅触发一次，触发完立即清除')
  triggerJSCompleteEvent = () => {
    if (this.JSComplete === true && this.JSCompleteEvent instanceof Array) {
      this.JSCompleteEvent.map(fn => {
        fn();
      });
      this.JSCompleteEvent = null;    //赋值非数组，标识已执行过
    }
  }

  @action('控制加载条')
  setLoading = (bool = false) => {
    this.loading = bool;
  }

  @action('控制按钮置灰')
  setBtnDisabled = (bool = true) => {
    this.btnDisabled = bool;
  }

  @action('API控制按钮置灰')
  setApiBtnDisabled = (bool = true) => {
    this.apiBtnDisabled = bool;
  }

  @action("控制发票云参数")
  setInvoiceCloudInfo = (invoiceCloudInfo) => {
    this.invoiceCloudInfo = invoiceCloudInfo;
  }

  @action('控制当前显示tab')
  setTabKey = (key) => {
    if (_.isEmpty(this.commonParam)) return;
    this.signReplyFlag = false; //清空回复的状态
    this.signReplyInfo = {}; //清空被回复人的信息
    this.tabKey = key;
    //记录tab项是否已点击过
    const variableKey = `haveClick_${key}`;
    !this.variableMap.has(variableKey) && this.controlVariableMap(variableKey, true);
  }

  @action('发送接口加载数据')
  loadBaseInfo = (queryParams) => {
    delete queryParams["_key"];
    this.urlParams = queryParams;
    if (this.urlParams.isPreView === "1")
      return this.loadPreViewInfo();
    const beforeFn = () => {
      //弹出连续处理切换提示
      this.pushJSCompleteEvent(() => {
        continuationProcessUtil.showConProcessSwitchTip(queryParams);
      });
      this.setLoading(true);
      window.API_LOAD_BEGIN = new Date().getTime();
    }
    const afterFn = (data) => {
      window.API_LOAD_END = new Date().getTime();
      window.API_DURATION = window.API_LOAD_END - window.API_LOAD_BEGIN;
      window.SERVER_DURATION = data.durationTime;
      this.doInit(queryParams, data);
      if (data.conflictFieldInfo && typeof data.conflictFieldInfo == 'object') {
        this.changeConflictFieldMap(data.conflictFieldInfo);
      }
      // if (data.odocInfo.docFlag && data.odocInfo.isInnerChange == '1') {
      //     this.addInnerChangeBtn = true;
      // }
    }
    EncryptUtil.verifyEncryptShare(this.urlParams, () => {
      EncryptUtil.verifySecondAuth(this.urlParams, beforeFn, afterFn);
    });
  }

  @action('加载表单信息')
  doInit = (queryParams, data) => {
    this.setLoading(false);
    const params = data.params;
    //无权限跳转
    if (params.verifyRight === false) {
      weaWfFormHistory && weaWfFormHistory.push("/main/workflow/ReqNoRight?isSecNoRight=" + params.isSecNoRight + "&isDelete=" + params.requestIsDelete + "&isTest=" + params.isTest);
      return;
    }
    //设置有效常用参数
    GlobalUtil.commonParamRange.map(v => {
      if (v in params) {
        this.commonParam[v] = params[v];
        delete params[v];
      }
    });

    //剩余无效参数(后期逐步去掉)
    this.invalidParam = params;
    //加载自定义样式文件
    GlobalUtil.loadCustomFiles("css");
    this.submitParam = data.submitParams;
    //密级信息
    this.secLevelInfo = data.secLevelInfo;
    //初始化模板及表单内容
    base.layoutStore.doInitLayout(data);
    Util.printDuration(this.commonParam, true);
    //更新请求信息及刷新待办，快速处理信息加载完毕后，再执行
    let updateReqInfoFunc = () => {
      const { requestid, iscreate, nodetype, wfmonitor, isurger, isprint } = this.commonParam;
      if (iscreate != "1" && isprint != '1') {
        const { submitParams = {} } = data;
        let updateReqInfoParams = { ...submitParams, requestid: requestid, currentnodetype: nodetype, wfmonitor: wfmonitor, isurger: isurger, ...GlobalUtil.getUpdateReqInfoFieldValue() };
        API_REQ.updateReqInfo(updateReqInfoParams).then(data => {
          //传参刷新列表，列表再依赖参数判断是否刷新
          this.pushJSCompleteEvent(() => {
            Util.reloadListPage({ from: "openReq", needReloadList: this.commonParam.needReloadList });
          });
        });
      }
    }
    //加载公文自定义页签
    this.getOdocTabManagerDatas();
    //加载顶部快速处理信息
    this.loadContinuationProcessInfo(queryParams, updateReqInfoFunc);
    //设置顶部提示信息
    this.promptInfos = data.promptInfos;
    //设置提醒类型信息
    this.remindInfo = data.remindInfo;
    //数据保护的验证信息
    this.secondAuthInfo = data.secondAuthInfo;
    //加载右键菜单
    this.loadRightMenu(queryParams);
    //加载签字意见输入框信息
    this.loadMarkInfo();
    //加载流程干预
    this.loadInterventionInfo();
    //tab扩展
    this.loadCustomTab();
    //显示CA认证的窗口
    this.showCAAuthDialog(data);
    //请求当前流程拥有的关注标签
    this.getFormAttentionTag();
    //加载水印
    this.pushJSCompleteEvent(Util.loadWaterMark);
    //加载发票云token
    if (this.commonParam.useInvoiceCloud == true) {
      getInvoiceCloudToken();
    }
    // if(params.openNodeCheck) {
    //   conformRule(); // 绑定合规
    // }
    let showSelectOtherEditMould = false;//有编辑模板替换时不走这里
    if ((data.odocInfo.docFlag && data.odocInfo.docParam.docid < 0 && data.odocInfo.docParam.editmouldCount > 1)
      || (data.odocInfo.docFlag && data.odocInfo.docParam.docid > 0 && data.odocInfo.docParam.reSelectMould)) {
      showSelectOtherEditMould = true;
    }
    if (data.odocInfo.docFlag && data.odocInfo.opentextdefaultnode && !data.odocInfo.docParam.isUseTempletNode && !showSelectOtherEditMould &&
      data.odocInfo.docParam.docid > 0 && !data.odocInfo.docParam.isTextInFormCanEdit && data.odocInfo.docParam.isEdit != 1) {
      setDocParam(WfForm.getOdocConfig())
      this.tabKey = 'odoc'
    }
  }

  @action('模板预览加载数据')
  loadPreViewInfo = () => {
    const preViewKey = this.urlParams.preViewKey;
    if (window.sessionStorage.getItem(preViewKey)) {
      const preViewData = JSON.parse(window.sessionStorage.getItem(preViewKey));
      API_REQ.loadPreViewInfo(preViewData).then(data => {
        console.log("preViewData", preViewData, "data", data);
        this.commonParam = data.params;
        base.layoutStore.doInitLayout(data);
      });
    } else {
      alert(`loadPreViewInfo Catch Exception: ${preViewKey}`);
    }
  }

  //打开CA认证的窗口
  showCAAuthDialog = (data) => {
    const isCAAuth = this.urlParams.isCAAuth;
    const CAKey = this.urlParams.CAKey;
    if (isCAAuth == "1") {
      const { secondAuthStore } = base;
      const { secondAuthConfig } = data;
      const { qysSignWay = 2, protectType } = secondAuthConfig;
      secondAuthStore.setCallbackFunc(doFileUpload);

      if (!!CAKey) {      //从缓存中先读取之前的数据
        secondAuthStore.readDataFromStorage(CAKey);
      }
      secondAuthStore.setParams(secondAuthConfig);

      if (protectType == authTypes.QYS && qysSignWay == 1) {
        window.QYSUKeyUtil.showSignWin(secondAuthStore);
      } else if (protectType == authTypes.CA_AUTH) {
        this.controlDialogVisible(authTypes.SECOND_AUTH_DIALOG, true);
      }
    }
  }

  @action('加载右键菜单')
  loadRightMenu = (queryParams) => {
    const params = { ...this.commonApiParam };
    //提交确认参数
    params.isaffirmanceSrc = queryParams.isaffirmanceSrc || "";
    params.isaffirmance = queryParams.isaffirmance || "";
    params.reEdit = queryParams.reEdit || "";
    API_REQ.getRightMenu(params).then(data => {
      data.rightMenus && data.rightMenus.sort((o1, o2) => {
        return o1.order - o2.order;
      });
      let _data = cloneDeep(data);
      this.checkShareBtn(_data)
      this.setRightMenu(data, false)
    });
  }

  @action('加载流程连续处理信息')
  loadContinuationProcessInfo = (queryParams, updateReqInfoFunc) => {
    if (queryParams.isOpenContinuationProcess == '1' && !queryParams.isRefresh == '1') {//连续处理进来，且不是刷新表单，获取连续处理信息
      let continuationProcessParams = continuationProcessUtil.getContinuationProcessParams();
      API_REQ.getContinnuationProcessInfo({ viewScope: "doing", currentRequestId: queryParams.requestid, ...continuationProcessParams }).then(data => {
        if (data.isOpenContinuationProcess && data.currentIndex >= 0) {
          this.continuationProcessInfo = { loaded: true, showSwitchBar: data.showSwitchBar, currentIndex: data.currentIndex, counts: data.count, requestId: queryParams.requestid }
        } else {
          this.urlParams.isOpenContinuationProcess = '0';
        }
        //更新请求信息及刷新待办，这里加3S延时，防止前一条流程提交完毕时，刷列表的事件被覆盖
        window.setTimeout(function () {
          updateReqInfoFunc();
        }, 3000);
      })
    } else {
      //更新请求信息及刷新待办
      updateReqInfoFunc();
    }

    //连续处理保存表单刷新流程，直接取上次的连续处理信息显示
    if (queryParams.isOpenContinuationProcess == '1' && queryParams.isRefresh == '1') {
      this.continuationProcessInfo = {
        loaded: true,
        isRefresh: '1',
        currentIndex: queryParams.currentIndex,
        counts: queryParams.counts,
        requestId: queryParams.requestid,
        showSwitchBar: queryParams.showSwitchBar
      }
    }
  }

  //判断是否显示分享按钮
  checkShareBtn = (data) => {
    const fn = () => {
      ecCom.WeaTools.checkJoin().then(res => {
        let { dingTalkShareSwitch = 0, emSwitch = 0, joinStatus = false, msgShowType, status, webSwitch = 0, wxWorkShareSwitch = 0, shareWorkflow = 0 } = res;
        let ua = window.navigator.userAgent;
        shareWorkflow = joinStatus == true && shareWorkflow == 1;
        if (/.*E-Mobile7.*/.test(ua) || /.*E-Mobile\/7.*/.test(ua)) {//Emobile7环境
          shareWorkflow = shareWorkflow && emSwitch == 1;
        } else if (/.*MicroMessenger.*/.test(ua)) {//微信
          shareWorkflow = shareWorkflow && wxWorkShareSwitch == 1;
        } else if (/.*DingTalk.*/.test(ua)) {//钉钉
          shareWorkflow = shareWorkflow && dingTalkShareSwitch == 1;
        }
        this.setRightMenu(data, shareWorkflow)
      })
    }
    this.pushJSCompleteEvent(fn);
  }

  @action('设置右键菜单')
  setRightMenu = (data = {}, shareWorkflow) => {
    if (!shareWorkflow) {//屏蔽分享按钮
      data.rightMenus && data.rightMenus.length > 0 ? data.rightMenus = data.rightMenus.filter(item => item.type !== "BTN_SHARE") : "";
    }
    let rightMenuNames = {};//右键菜单对应的自定义名称
    data.rightMenus && data.rightMenus.length > 0 && data.rightMenus.map(item => {
      const { systemMenuType = '', systemSmallType = 0, menuName = '' } = item;
      if (systemMenuType.length > 0 && menuName.length > 0) {
        rightMenuNames[`${systemMenuType}_${systemSmallType}`] = menuName;
      }
    })
    data.rightMenuNames = rightMenuNames;
    this.rightMenu = data;
    const { isImportDetail } = data;
    if (isImportDetail && this.urlParams.saveType === "doImportDetail") {
      this.controlDialogVisible(type.IMPORT_WF_DETAIL_MODAL, true);
    }
    //流程点击流转设置保存流程时，重新打开流转设置
    const { requestid = -1 } = this.commonParam;
    const { isAllowNodeFreeFlow, isFree } = data;
    let isDefaultOpenFreeFlowSetDialog = window.localStorage.getItem('WfFormIsDefaultOpenFreeFlowSetDialog');
    if (requestid > 0 && isDefaultOpenFreeFlowSetDialog == '1' && (isAllowNodeFreeFlow == '1' || isFree == '1')) {
      window.localStorage.removeItem('WfFormIsDefaultOpenFreeFlowSetDialog');
      if (this.JSComplete) {
        doFreeWorkflow();
      } else {
        this.JSCompleteEvent.push(doFreeWorkflow);
      }
    }
  }

  @action('改变提交参数')
  changeSubmitParam = (param = {}) => {
    this.submitParam = { ...this.submitParam, ...param };
  }

  @action('设置提交到指定节点')
  setSubmitToNodeId = (isFromSubmitToReject = false) => {
    const { isSubmitDirectNode, lastnodeid } = this.rightMenu;
    let { canSubmitToRejectNode = true } = this.commonParam;
    if (this.variableMap.has('canSubmitToRejectNode')) {
      canSubmitToRejectNode = this.variableMap.get('canSubmitToRejectNode');
    }
    if ((isSubmitDirectNode == '1' || isFromSubmitToReject) && canSubmitToRejectNode) {
      this.changeSubmitParam({ SubmitToNodeid: lastnodeid });
    }
  }

  @action('设置关闭是否需要提示')
  setCloseNeedPrompt = (bool = true) => {
    this.closeNeedPrompt = bool;
  }

  @action('控制右键弹窗')
  controlDialogVisible = (key, value) => {
    this.dialogVisible.set(key, value);
  }

  @action('加载签字意见输入信息')
  loadMarkInfo = (isInit = true) => {
    const { isHideInput = '0', wfTestStr, requestType, intervenorright } = this.commonParam;
    let signInputParams = { ...this.baseParam };
    signInputParams.wfTestStr = wfTestStr;
    if (isHideInput != '1' && (requestType > 0 || intervenorright > 0)) {
      this.setBtnDisabled(true);
      API_REQ.getSignInput(signInputParams).then(data => {
        data.hasLoadMarkInfo = true;
        const { remarkquote = [] } = data;
        this.setMarkInfo(data);
        if (isInit) {
          const { remarkInfo = {} } = data;
          //设置默认值到submitParams
          const updateParams = {
            'remark': remarkInfo['remark'],
            'field-annexupload': remarkInfo['field-annexupload'],
            'signdocids': remarkInfo['signdocids'],
            'signworkflowids': remarkInfo['signworkflowids'],
            'remarkLocation': remarkInfo['remarkLocation']
          }
          this.changeSubmitParam(updateParams);
          let remarkQuoteDatas = observable.map ? observable.map({}) : asMap({});;
          remarkquote.forEach((v, i) => {
            remarkQuoteDatas.set(`key_${i}`, v);
          });
          this.controlVariableMap('remark_list', remarkQuoteDatas);
          this.controlVariableMap('remark_list_index', remarkquote.length);
          this.btnLabelName = data.btnLabelName;
        }
        this.setBtnDisabled(false);
      });
    } else {
      API_REQ.getNodeSignSet(signInputParams).then(data => {
        this.setMarkInfo(data);
      });
      this.setBtnDisabled(false);
    }
  }

  @action
  setMarkInfo = (data = {}) => {
    this.markInfo = data;
  }

  @action("加载流程干预信息")
  loadInterventionInfo = () => {
    const { intervenorright = 0 } = this.commonParam;
    if (intervenorright > 0) {
      API_REQ.getReqInterventionInfo(this.commonApiParam).then(data => {
        this.setInvertionInfo(data);
        this.changeSubmitParam(Util.getIntervenorDefaultV(data));
        this.setInterventionUserReplacedata(data);
      })
    }
  }

  @action
  setInvertionInfo = (data = {}) => {
    this.invertionInfo = { ...this.invertionInfo, ...data };
  }

  @action("流程干预切换节点")
  getInterventionUser = (selectednodeinfo = {}) => {
    API_REQ.getInterventionUser({ ...this.commonApiParam, ...selectednodeinfo }).then((data) => {
      this.setInvertionInfo(data);
      this.changeSubmitParam(Util.getIntervenorDefaultV(data));
      this.setInterventionUserReplacedata(data);
    });
  }

  @action("流程干预切换节点")
  setInterventionUserReplacedata = (data = {}) => {
    let { items = [] } = data;
    let nodeOperators = data.replacedatas || [];
    let nodeOperators_crm = data.replacedatas_crm || [];//客户浏览按钮
    if (items.length > 0) {
      items.map((item) => {
        const { conditionType, domkey = [], browserConditionParam = {} } = item;
        if (conditionType == 'BROWSER') {
          const { replaceDatas = [] } = browserConditionParam;
          if ('Intervenorid' == domkey[0]) nodeOperators = replaceDatas;
          if ('Intervenorid_crm' == domkey[0]) nodeOperators_crm = replaceDatas;
        }
      });
    }
    let viewAttr = 3;
    console.log(nodeOperators, nodeOperators_crm);
    if (nodeOperators.length > 0 || nodeOperators_crm.length > 0) viewAttr = 2;
    this.controlVariableMap("Intervenorid_replaceDatas", nodeOperators);
    this.controlVariableMap("Intervenorid_crm_replaceDatas", nodeOperators_crm);
    this.controlVariableMap("Intervenorid_viewAttr", viewAttr);
    this.controlVariableMap("Intervenorid_crm_viewAttr", viewAttr);
  }

  @action("重置状态")
  resetStore = () => {
    this.promptInfo = {};
  }

  @action("获取扩展Tab")
  loadCustomTab = () => {
    const _this = this;
    API_REQ.getFormTab(this.commonApiParam).then((data = {}) => {
      const { customTabs = [] } = data;
      const customFiles = [];
      customTabs.map((tab = {}, index) => {
        const { filePath = '' } = tab;
        if (filePath.endsWith(".js")) {
          customFiles.push(filePath);
        }
      });
      if (customTabs.length > 0) {
        _this.controlVariableMap("customTabs", customTabs);
        const init = () => {
          if (window.console) console.log("customFiles加载成功！")
        }
        loadjs.isDefined('workflowCustomTab') ? loadjs.ready('workflowCustomTab', init) : loadjs(customFiles, 'workflowCustomTab', init);
      }
    });
  }

  @action("修改表单密级信息")
  setSecLevelInfo = (obj) => {
    this.secLevelInfo = { ...this.secLevelInfo, ...obj };
    if (window.oDocUtil) window.oDocUtil.needReconfirmSecretLevel = true;//流程密级改变时，需重新确认正文密级
  }

  @action("更新commonParam值")
  updateCommonParam = (k, v) => {
    this.commonParam[k] = v;
  }

  @action("更新remindInfo")
  updateRemindInfo = (data = {}) => {
    this.remindInfo = { ...data };
  }

  @action("请求当前流程拥有的关注标签")
  getFormAttentionTag = () => {
    const { requestid, wfmonitor, f_weaver_belongto_userid, f_weaver_belongto_usertype, authSignatureStr, authStr, signatureAttributesStr, signatureSecretKey } = this.commonParam;
    if (wfmonitor)
      return;
    let params = {
      requestid,
      f_weaver_belongto_userid,
      f_weaver_belongto_usertype,
      authSignatureStr,
      authStr,
      signatureAttributesStr,
      signatureSecretKey
    }
    API_REQ.getFormAttentionTag(params).then(result => {
      //把结果跟在标题的后面
      const { titlename } = result;
      this.controlVariableMap("attention_titlename", titlename)
    })
  }

  @action("获取手写签批内容并放入变量区")
  changeHandWritingData = (type, val = []) => {
    this.controlVariableMap(type, val)
  }
  @action('设置流程二次确认提示信息')
  setPromptInfo = val => {
    this.promptInfo = val;
  }

  @action
  setPromptInfos = val => {
    this.promptInfos = [val];
    this.controlVariableMap("forceRenderReq", (this.variableMap.get("forceRender") || 0) + 1);
  }

  @action jumpTab = (queryParams = {}, commonParam = {}) => {
    //如果指定了tab,加载完成后跳到对应的tab
    if (queryParams.jumpTab) {
      if (queryParams.jumpTab == 'communication' && commonParam.isOpenCommunication == 0) {

      } else {
        Util.switchFormTabFunc(queryParams.jumpTab);
      }
    }
  }

  @action('冲突字段值记录')
  changeConflictFieldMap = (obj) => {
    if (typeof obj != 'object') return
    let keys = Object.keys(obj);
    keys.length > 0 && keys.map(key => {
      this.conflictFieldMap.set(key, obj[key]);
    })
  }

  /*-------------公文交换----------------*/
  @observable addInnerChangeBtn = false;//是否加载公文交换右键菜单
  @observable innerChangeDialog = false;//内部交换弹窗显隐

  @action
  setInnerChangeDialog = (bool) => {
    this.innerChangeDialog = bool;
  }

  @observable FreeflowChangeformParm = {};//自由流程设置表单后台配置信息
  @observable freeflowChangeformParmfixedForm = null;//自由流程设置表单后台配置信息
  @observable FreeflowChangeformParmconditions = [];//自由流程设置表单后台配置信息

  @action
  setFreeflowChangeformParm = (obj) => {
    this.FreeflowChangeformParm = obj;
  }
  @action
  getFreeNodeBrowserItem = (parm) => {
    this.FreeflowChangeformParm = parm;

    const { WeaForm } = getComsMobx();
    this.freeflowChangeformParmfixedForm = new WeaForm();

    API_REQ.getFreeNodeBrowserItem({ workflowid: parm.wfid }).then((data) => {
      if (data) {
        let addFormConditions1 = [
          {
            "defaultshow": true,
            "items": [],
            "title": ""
          }
        ]
        addFormConditions1[0].items.push(data.data[0])
        this.freeflowChangeformParmfixedForm.initFormFields(addFormConditions1);
        this.FreeflowChangeformParmconditions = addFormConditions1
        this.controlDialogVisible(type.FREE_FLOW_CHANGEFORM, true);

      }
    }).catch(() => {
      let addFormConditions1 = [{ "defaultshow": true, "items": [{ "belong": "PC", "checkbox": false, "checkboxValue": false, "colSpan": 2, "conditionType": "SELECT", "dateGroup": false, "defaultDisplayInBar": false, "detailtype": 1, "domkey": ["defaultStyle"], "entSearch": false, "fieldcol": 18, "hasBorder": false, "helpfulTipProps": {}, "hide": false, "isBase64": false, "isQuickSearch": false, "label": "浏览类型字段格式", "labelcol": 6, "length": 0, "maxFilesNumber": 0, "maxUploadSize": 0, "multiSelection": false, "multiple": false, "options": [{ "disabled": false, "key": "0", "selected": true, "showname": "名称", "visible": true }, { "disabled": false, "key": "1", "selected": false, "showname": "##主键", "visible": true }, { "disabled": false, "key": "2", "selected": false, "showname": "名称##主键", "visible": true }], "precision": 0, "showOrder": 0, "showTime": false, "stringLength": 0, "supportCancel": false, "tipPosition": "bottom", "valueList": [], "viewAttr": 2 }], "title": "默认设置" }, { "defaultshow": true, "items": [{ "belong": "PC", "checkbox": false, "checkboxValue": false, "colSpan": 2, "conditionType": "SELECT_LINKAGE", "dateGroup": false, "defaultDisplayInBar": false, "detailtype": 1, "domkey": ["resourceStyle"], "entSearch": false, "fieldcol": 18, "hasBorder": false, "helpfulTipProps": {}, "hide": false, "isBase64": false, "isQuickSearch": false, "label": "人力资源字段格式", "labelcol": 6, "length": 0, "maxFilesNumber": 0, "maxUploadSize": 0, "multiSelection": false, "multiple": false, "options": [{ "disabled": false, "key": "0", "selected": true, "showname": "默认设置", "visible": true }, { "disabled": false, "key": "1", "selected": false, "showname": "自定义设置", "visible": true }], "precision": 0, "selectLinkageDatas": { "1": { "belong": "PC", "checkbox": false, "checkboxValue": false, "colSpan": 2, "conditionType": "SELECT", "dateGroup": false, "defaultDisplayInBar": false, "detailtype": 1, "domkey": ["resourceChild"], "entSearch": false, "fieldcol": 18, "hasBorder": false, "helpfulTipProps": {}, "hide": false, "isBase64": false, "isQuickSearch": false, "labelcol": 6, "length": 0, "maxFilesNumber": 0, "maxUploadSize": 0, "multiSelection": false, "multiple": false, "options": [{ "disabled": false, "key": "0", "selected": true, "showname": "名称", "visible": true }, { "disabled": false, "key": "1", "selected": false, "showname": "##主键", "visible": true }, { "disabled": false, "key": "2", "selected": false, "showname": "名称##主键", "visible": true }, { "disabled": false, "key": "3", "selected": false, "showname": "deptcode_具体编号", "visible": true }, { "disabled": false, "key": "4", "selected": false, "showname": "名称deptcode_具体编号", "visible": true }, { "disabled": false, "key": "5", "selected": false, "showname": "组织全路径", "visible": true }], "precision": 0, "showOrder": 0, "showTime": false, "stringLength": 0, "supportCancel": false, "tipPosition": "bottom", "valueList": [], "viewAttr": 2 } }, "showOrder": 0, "showTime": false, "stringLength": 0, "supportCancel": false, "tipPosition": "bottom", "valueList": [], "viewAttr": 2 }, { "belong": "PC", "checkbox": false, "checkboxValue": false, "colSpan": 2, "conditionType": "SELECT_LINKAGE", "dateGroup": false, "defaultDisplayInBar": false, "detailtype": 1, "domkey": ["departStyle"], "entSearch": false, "fieldcol": 18, "hasBorder": false, "helpfulTipProps": {}, "hide": false, "isBase64": false, "isQuickSearch": false, "label": "部门字段格式", "labelcol": 6, "length": 0, "maxFilesNumber": 0, "maxUploadSize": 0, "multiSelection": false, "multiple": false, "options": [{ "disabled": false, "key": "0", "selected": true, "showname": "默认设置", "visible": true }, { "disabled": false, "key": "1", "selected": false, "showname": "自定义设置", "visible": true }], "precision": 0, "selectLinkageDatas": { "1": { "belong": "PC", "checkbox": false, "checkboxValue": false, "colSpan": 2, "conditionType": "SELECT", "dateGroup": false, "defaultDisplayInBar": false, "detailtype": 1, "domkey": ["departChild"], "entSearch": false, "fieldcol": 18, "hasBorder": false, "helpfulTipProps": {}, "hide": false, "isBase64": false, "isQuickSearch": false, "labelcol": 6, "length": 0, "maxFilesNumber": 0, "maxUploadSize": 0, "multiSelection": false, "multiple": false, "options": [{ "disabled": false, "key": "0", "selected": true, "showname": "名称", "visible": true }, { "disabled": false, "key": "1", "selected": false, "showname": "##主键", "visible": true }, { "disabled": false, "key": "2", "selected": false, "showname": "名称##主键", "visible": true }, { "disabled": false, "key": "3", "selected": false, "showname": "deptcode_具体编号", "visible": true }, { "disabled": false, "key": "4", "selected": false, "showname": "名称deptcode_具体编号", "visible": true }, { "disabled": false, "key": "5", "selected": false, "showname": "组织全路径", "visible": true }], "precision": 0, "showOrder": 0, "showTime": false, "stringLength": 0, "supportCancel": false, "tipPosition": "bottom", "valueList": [], "viewAttr": 2 } }, "showOrder": 0, "showTime": false, "stringLength": 0, "supportCancel": false, "tipPosition": "bottom", "valueList": [], "viewAttr": 2 }, { "belong": "PC", "checkbox": false, "checkboxValue": false, "colSpan": 2, "conditionType": "SELECT_LINKAGE", "dateGroup": false, "defaultDisplayInBar": false, "detailtype": 1, "domkey": ["subCompanyStyle"], "entSearch": false, "fieldcol": 18, "hasBorder": false, "helpfulTipProps": {}, "hide": false, "isBase64": false, "isQuickSearch": false, "label": "分部字段格式", "labelcol": 6, "length": 0, "maxFilesNumber": 0, "maxUploadSize": 0, "multiSelection": false, "multiple": false, "options": [{ "disabled": false, "key": "0", "selected": true, "showname": "默认设置", "visible": true }, { "disabled": false, "key": "1", "selected": false, "showname": "自定义设置", "visible": true }], "precision": 0, "selectLinkageDatas": { "1": { "belong": "PC", "checkbox": false, "checkboxValue": false, "colSpan": 2, "conditionType": "SELECT", "dateGroup": false, "defaultDisplayInBar": false, "detailtype": 1, "domkey": ["subCompanyChild"], "entSearch": false, "fieldcol": 18, "hasBorder": false, "helpfulTipProps": {}, "hide": false, "isBase64": false, "isQuickSearch": false, "labelcol": 6, "length": 0, "maxFilesNumber": 0, "maxUploadSize": 0, "multiSelection": false, "multiple": false, "options": [{ "disabled": false, "key": "0", "selected": true, "showname": "名称", "visible": true }, { "disabled": false, "key": "1", "selected": false, "showname": "##主键", "visible": true }, { "disabled": false, "key": "2", "selected": false, "showname": "名称##主键", "visible": true }, { "disabled": false, "key": "3", "selected": false, "showname": "deptcode_具体编号", "visible": true }, { "disabled": false, "key": "4", "selected": false, "showname": "名称deptcode_具体编号", "visible": true }, { "disabled": false, "key": "5", "selected": false, "showname": "组织全路径", "visible": true }], "precision": 0, "showOrder": 0, "showTime": false, "stringLength": 0, "supportCancel": false, "tipPosition": "bottom", "valueList": [], "viewAttr": 2 } }, "showOrder": 0, "showTime": false, "stringLength": 0, "supportCancel": false, "tipPosition": "bottom", "valueList": [], "viewAttr": 2 }], "title": "组织字段自定义设置" }]
      this.freeflowChangeformParmfixedForm.initFormFields(addFormConditions1);
      this.FreeflowChangeformParmconditions = addFormConditions1;
      this.controlDialogVisible(type.FREE_FLOW_CHANGEFORM, true);

    });

  }


  /**---------------公文自定义页签------------------- */
  @observable odocCustomTabs = [];
  @observable isDefaultOpenOdoc = false;

  //获取自定义页签
  @action
  getOdocTabManagerDatas = () => {
    const { requestid, workflowid, f_weaver_belongto_userid, f_weaver_belongto_usertype } = this.commonParam;
    API_REQ.getOdocTabManagerDatas({
      requestid: requestid,
      workflowid: workflowid,
      f_weaver_belongto_userid: f_weaver_belongto_userid,
      f_weaver_belongto_usertype: f_weaver_belongto_usertype,
    }).then(data => {
      if (data.api_status && data.api_status == true) {
        this.odocCustomTabs = data.customTabs;
        this.isDefaultOpenOdoc = data.isDefaultOpenOdoc || false;
      }
    })
  }

}


// WEBPACK FOOTER //
// ../src4js/pc4mobx/workflowForm/stores/global.js